export default "__VITE_ASSET__DGPUbJ04__"